import StaticPage from "layouts/StaticPage"
import { startCase } from "lodash-es"
import React from "react"

const permissions = {
  location: [
    "Approximate location (network based)",
    "Precise location (GPS and network based)",
  ],
  phone: ["Read phone status and identity", "Directly call phone numbers"],
  camera: ["Take pictures and videos"],
  others: [
    "Receive data from internet",
    "Full network access",
    "Access to internal storage",
  ],
}
const Privacy = () => (
  <StaticPage>
    <div>
      <h6 className="mb-0">Privacy Policy</h6>
      <p className="mb-4">Vesatogo app has access to the below features.</p>

      {Object.keys(permissions).map(key => (
        <div className="mb-3 last:mb-0" key={key}>
          <span className="font-500 ">{startCase(key)}</span>
          <ul className="list-decimal">
            {permissions[key].map((permission: string) => (
              <li key={permission}>{permission}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </StaticPage>
)

export default Privacy
